import '@cloudscape-design/global-styles/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { setUser, userManager } from './auth/userManager.js';
import { initConfig } from './config.js';

async function bootstrap(): Promise<void> {
  await initConfig();
  const um = userManager();
  if (um) {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has('code') && params.has('state')) {
        const user = await um.signinRedirectCallback();
        setUser(user);
        window.history.replaceState({}, '', window.location.pathname);
      } else {
        const existing = await um.getUser();
        if (existing && !existing.expired) setUser(existing);
      }
    } catch (err) {
      console.error('auth bootstrap error', err);
    }
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('root element not found');
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
